(function () {
    'use strict';

    var module = angular.module('uwAgenda.ringfoon');

    // directive for quick sidebar task item
    module.directive('quickSidebarTask', 
        ['TaskService', 'AgendaTransitionService', 'TaskStateEnum', 'QuickSidebarTasksService', 'HelperService',
        function (TaskService, AgendaTransitionService, TaskStateEnum, QuickSidebarTasksService, HelperService) {
        var directive = {
            restrict: 'E',
            templateUrl: '/app/ringfoon/templates/quick-sidebar-task.template.html',
            scope: {
                task: '=',
                showActions: '@?',
                toggleSidebar: '@?'
            },
            link: link

        };
        return directive;

        function link(scope, element) {
            if (scope.task.taskFlag) {
                scope.borderColor = scope.task.taskFlag.color;
            }
            if (scope.task.taskState === TaskStateEnum.FollowUpByRingfoon.value) {
                scope.borderColor = 'red-thunderbird';
            }
            if(scope.task.isImportant === true) {
                scope.borderColor = 'border-indigo';
            }

            scope.navigateToTask = function() {
                // switch to agenda en open
                QuickSidebarTasksService.data.current = scope.task;
                AgendaTransitionService.change(scope.task.agendaOwnerId, scope.task.switchDate);
            }

            // confirm and pin
            scope.confirmAndPin = function (event) {     
                event.stopPropagation();
                TaskService.confirmAndPin(scope.task.id);
            };

            // confirm and not pin
            scope.confirmAndNotPin = function (event) {
                event.stopPropagation();
                TaskService.confirmAndNotPin(scope.task.id);
            };

            scope.goToAgenda = function() {                
                AgendaTransitionService.change(scope.task.agendaOwnerId, scope.task.switchDate);
            }


            // destroy
            scope.$on('$destroy', function () {
            });

        }

    }]);

})();